// react
import React, { useEffect, useState } from 'react';
import EmptyState from '../shared/EmptyState';

// third-party
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';

// data stubs
import PageHeader from '../shared/PageHeader';
import theme from '../../data/theme';
import { resetAuth } from '../../store/auth/authActions';
import { useOrderTimer } from '../../services/orderTimer';

export default function AccountPageOrderDetails(props) {
    const params = useParams();
    const txCode = props.transactioncode || props.match?.params?.transactioncode || props.match?.params?.OrderId || params?.transactioncode || params?.OrderId || '';

    const [address, setAddress] = useState('');
    const [nama, setNama] = useState('');
    const [date, setDate] = useState('');
    const [rawDate, setRawDate] = useState('');
    const [orderId, setOrderId] = useState('');
    const [ongkir, setOngkir] = useState(0);
    const [totalprice, setTotalPrice] = useState(0);
    const [subtotal, setSubTotal] = useState(0);
    const [phone, setPhone] = useState('');
    const [item, setItem] = useState([]);
    const [lacak, setLacak] = useState([]);
    const [status, setStatus] = useState(0);
    const [bankName, setBankName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [copied, setCopied] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const timer = useOrderTimer(orderId, txCode, rawDate);

    const dispatch = useDispatch();
    const { token } = useSelector((state) => state.auth);

    const formatRupiah = (money) => {
        const num = parseFloat(money) || 0;
        return new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0,
        }).format(num);
    };

    const handleCopy = (text) => {
        if (!text) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(String(text));
        } else {
            const el = document.createElement('textarea');
            el.value = String(text);
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }
        setCopied(true);
        toast.success('Kode transaksi berhasil disalin!');
        setTimeout(() => setCopied(false), 2000);
    };

    useEffect(() => {
        const activeToken = token || localStorage.getItem('token');

        const getTransaksi = async () => {
            if (!txCode) {
                setIsLoading(false);
                return;
            }

            try {
                setIsLoading(true);
                const result = await axios.get(
                    `${process.env.REACT_APP_HOST_API}/transaction/detail/${txCode}`,
                    {
                        headers: {
                            Authorization: `Bearer ${activeToken}`,
                        },
                    }
                );

                const resData = result.data?.response;
                const soDetail = resData?.soCommerceDetail || {};

                setNama(soDetail.user_name || '-');
                setTotalPrice(soDetail.payment_total || resData?.transaction_total || 0);
                setSubTotal(soDetail.price_total || 0);
                setOngkir(soDetail.ongkir || 0);
                setDate(resData?.transaction_date ? moment(resData.transaction_date).format('DD MMMM YYYY, HH:mm') : '-');
                setRawDate(resData?.transaction_date || '');
                setOrderId(resData?.id || soDetail?.id || '');
                setAddress(soDetail.manual_address || '-');
                setPhone(soDetail.phone || '-');
                setStatus(soDetail.pic2_state !== undefined ? Number(soDetail.pic2_state) : 0);
                setBankName(resData?.bank_name || soDetail?.bank_name || '');
                setAccountNumber(resData?.account_number || soDetail?.account_number || '');

                if (soDetail.id) {
                    getitemso(soDetail.id, activeToken);
                }
                if (soDetail.kurir_id && soDetail.keterangan) {
                    getLacak(soDetail.kurir_id, soDetail.keterangan, activeToken);
                }
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching transaction detail:', error);
                setIsLoading(false);

                // Fallback to CO-INFO in localStorage if matching
                try {
                    const storedCo = localStorage.getItem('CO-INFO');
                    if (storedCo) {
                        const parsed = JSON.parse(storedCo);
                        if (parsed.transaction_code === txCode) {
                            setTotalPrice(parsed.transaction_total || 0);
                            setDate(parsed.transaction_date || '');
                            setRawDate(parsed.transaction_date || '');
                            setOrderId(parsed.id || '');
                            setBankName(parsed.bank_name || '');
                            setAccountNumber(parsed.account_number || '');
                        }
                    }
                } catch (e) {
                    // ignore fallback error
                }
            }
        };

        const getitemso = async (id, currentToken) => {
            try {
                const result = await axios.post(
                    `${process.env.REACT_APP_HOST_API}/so-commerce/item`,
                    { sc_id: id },
                    {
                        headers: {
                            Authorization: `Bearer ${currentToken}`,
                        },
                    }
                );
                const rawItems = result.data?.response || [];
                setItem(rawItems);

                // Enrich missing image_url asynchronously from catalog
                rawItems.forEach(async (it, idx) => {
                    if (!it.image_url && !it.photo) {
                        try {
                            let foundUrl = null;
                            if (it.item_id) {
                                const getRes = await axios.get(`${process.env.REACT_APP_HOST_API}/items-searching/get/${it.item_id}`);
                                foundUrl = getRes.data?.response?.image_url;
                            }
                            if (!foundUrl && it.item_name) {
                                const pageRes = await axios.post(`${process.env.REACT_APP_HOST_API}/items-searching/page`, {
                                    page: 1,
                                    per_page: 5,
                                    item_name: it.item_name,
                                });
                                const match = pageRes.data?.response?.find((p) => p.item_name === it.item_name) || pageRes.data?.response?.[0];
                                foundUrl = match?.image_url;
                            }
                            if (foundUrl) {
                                setItem((prev) => {
                                    const updated = [...prev];
                                    if (updated[idx]) {
                                        updated[idx] = { ...updated[idx], image_url: foundUrl };
                                    }
                                    return updated;
                                });
                            }
                        } catch (e) {
                            // ignore silent fallback
                        }
                    }
                });
            } catch (error) {
                console.error('Error fetching items:', error);
            }
        };

        const getLacak = async (courierId, awb, currentToken) => {
            try {
                const result = await axios.get(
                    `${process.env.REACT_APP_HOST_API}/kurir/track?courier_id=${courierId}&awb=${awb}`,
                    {
                        headers: {
                            Authorization: `Bearer ${currentToken}`,
                        },
                    }
                );
                setLacak(result.data?.response?.history || []);
            } catch (error) {
                console.error('Error fetching tracking:', error);
            }
        };

        if (activeToken && txCode) {
            getTransaksi();
        } else {
            setIsLoading(false);
        }
    }, [token, txCode, dispatch]);

    const getStatusBadge = (state) => {
        switch (Number(state)) {
            case 0:
                return { label: 'Menunggu Pembayaran', badgeClass: 'status-pending', icon: 'fas fa-hourglass-half' };
            case 1:
                return { label: 'Dibatalkan Pembeli', badgeClass: 'status-cancelled', icon: 'fas fa-times-circle' };
            case 2:
                return { label: 'Dibatalkan Toko', badgeClass: 'status-cancelled', icon: 'fas fa-times-circle' };
            case 3:
                return { label: 'Sedang Diproses', badgeClass: 'status-processing', icon: 'fas fa-box' };
            case 4:
                return { label: 'Tiba di Gudang', badgeClass: 'status-processing', icon: 'fas fa-warehouse' };
            case 5:
                return { label: 'Tiba di Toko', badgeClass: 'status-processing', icon: 'fas fa-store' };
            case 6:
                return { label: 'Dalam Pengiriman', badgeClass: 'status-shipping', icon: 'fas fa-truck' };
            case 7:
                return { label: 'Telah Sampai', badgeClass: 'status-completed', icon: 'fas fa-check-circle' };
            case 8:
                return { label: 'Pengembalian', badgeClass: 'status-cancelled', icon: 'fas fa-undo' };
            case 9:
                return { label: 'Pesanan Selesai', badgeClass: 'status-completed', icon: 'fas fa-check-circle' };
            default:
                return { label: 'Menunggu Pembayaran', badgeClass: 'status-pending', icon: 'fas fa-hourglass-half' };
        }
    };

    const statusBadge = getStatusBadge(status);

    const waConfirmText =
        `Halo Admin Hokky Bangunan, saya ingin konfirmasi pembayaran untuk pesanan:
• No. Transaksi: ${txCode}
• Total: ${formatRupiah(totalprice)}
• Tanggal: ${date}

Berikut saya kirimkan bukti pembayarannya. Mohon segera dicek. Terima kasih!`;

    const waConfirmUrl = `https://wa.me/6281230553236?text=${encodeURIComponent(waConfirmText)}`;

    const waHelpText =
        `Halo Admin Hokky Bangunan, saya butuh informasi mengenai pesanan #${txCode}.`;
    const waHelpUrl = `https://wa.me/6281230553236?text=${encodeURIComponent(waHelpText)}`;

    const breadcrumb = [
        { title: 'Home', url: '/' },
        { title: 'Transaksi', url: '/account/orders' },
        { title: `Detail #${txCode || ''}`, url: '' },
    ];

    if (isLoading) {
        return (
            <div className="order-details-page-block">
                <Helmet>
                    <title>{`Detail Pesanan #${txCode || ''} | ${theme.name}`}</title>
                </Helmet>
                <PageHeader breadcrumb={breadcrumb} />
                <div className="container hokky-cart-container">
                    <div className="order-details-header-card" style={{ pointerEvents: 'none' }}>
                        <div className="header-title-left">
                            <div className="header-main-title">
                                <span className="skeleton-bone" style={{ width: 170, height: 28, borderRadius: 6 }} />
                                <span className="skeleton-bone" style={{ width: 130, height: 26, borderRadius: 8 }} />
                            </div>
                            <span className="skeleton-bone" style={{ width: 220, height: 16, borderRadius: 4, marginTop: 4 }} />
                        </div>
                        <div className="header-status-right">
                            <span className="skeleton-bone skeleton-bone--pill" style={{ width: 140, height: 32 }} />
                            <span className="skeleton-bone" style={{ width: 140, height: 34, borderRadius: 10 }} />
                        </div>
                    </div>

                    <div className="order-details-grid" style={{ pointerEvents: 'none' }}>
                        <div className="order-details-main-col">
                            <div className="order-section-card">
                                <div className="card-header-clean">
                                    <span className="skeleton-bone" style={{ width: 140, height: 22, borderRadius: 5 }} />
                                    <span className="skeleton-bone skeleton-bone--pill" style={{ width: 75, height: 20 }} />
                                </div>
                                <div className="order-products-list">
                                    {[1, 2].map((i) => (
                                        <div key={i} className="order-product-row">
                                            <div className="product-thumb-box">
                                                <span className="skeleton-bone" style={{ width: '100%', height: '100%', borderRadius: 8 }} />
                                            </div>
                                            <div className="product-info-col">
                                                <span className="skeleton-bone" style={{ width: '75%', height: 16, borderRadius: 4, marginBottom: 8 }} />
                                                <span className="skeleton-bone" style={{ width: 120, height: 14, borderRadius: 4 }} />
                                            </div>
                                            <div className="product-total-col">
                                                <span className="skeleton-bone" style={{ width: 90, height: 18, borderRadius: 4 }} />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="order-summary-breakdown">
                                    <div className="summary-line">
                                        <span className="skeleton-bone" style={{ width: 110, height: 14, borderRadius: 4 }} />
                                        <span className="skeleton-bone" style={{ width: 80, height: 14, borderRadius: 4 }} />
                                    </div>
                                    <div className="summary-line">
                                        <span className="skeleton-bone" style={{ width: 90, height: 14, borderRadius: 4 }} />
                                        <span className="skeleton-bone" style={{ width: 70, height: 14, borderRadius: 4 }} />
                                    </div>
                                    <div className="summary-line total-line">
                                        <span className="skeleton-bone" style={{ width: 120, height: 18, borderRadius: 4 }} />
                                        <span className="skeleton-bone" style={{ width: 110, height: 22, borderRadius: 6 }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="order-details-side-col">
                            <div className="order-section-card">
                                <div className="card-header-clean">
                                    <span className="skeleton-bone" style={{ width: 160, height: 22, borderRadius: 5 }} />
                                </div>
                                <div className="sidebar-info-block">
                                    <span className="skeleton-bone" style={{ width: 70, height: 12, borderRadius: 4, marginBottom: 6 }} />
                                    <span className="skeleton-bone" style={{ width: 150, height: 18, borderRadius: 4, marginBottom: 6 }} />
                                    <span className="skeleton-bone" style={{ width: 120, height: 14, borderRadius: 4, marginBottom: 14 }} />
                                    <span className="skeleton-bone" style={{ width: 100, height: 12, borderRadius: 4, marginBottom: 6 }} />
                                    <span className="skeleton-bone" style={{ width: '90%', height: 14, borderRadius: 4, marginBottom: 4 }} />
                                    <span className="skeleton-bone" style={{ width: '70%', height: 14, borderRadius: 4 }} />
                                </div>
                            </div>
                            <div className="order-section-card">
                                <div className="card-header-clean">
                                    <span className="skeleton-bone" style={{ width: 110, height: 22, borderRadius: 5 }} />
                                </div>
                                <div className="sidebar-info-block">
                                    <span className="skeleton-bone" style={{ width: 160, height: 18, borderRadius: 4, marginBottom: 8 }} />
                                    <span className="skeleton-bone" style={{ width: '85%', height: 14, borderRadius: 4, marginBottom: 12 }} />
                                    <span className="skeleton-bone" style={{ width: 120, height: 14, borderRadius: 4 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="order-details-page-block">
            <Helmet>
                <title>{`Detail Pesanan #${txCode || ''} | ${theme.name}`}</title>
            </Helmet>

            <PageHeader breadcrumb={breadcrumb} />

            <div className="container hokky-cart-container">

                {/* Master Header Card */}
                <div className="order-details-header-card">
                    <div className="header-title-left">
                        <div className="header-main-title">
                            <h1>Detail Transaksi</h1>
                            <span className="order-code-badge">
                                #{txCode}
                                {txCode && (
                                    <button
                                        type="button"
                                        className="btn-copy-sm"
                                        title="Salin Kode Transaksi"
                                        onClick={() => handleCopy(txCode)}
                                    >
                                        <i className={copied ? 'fas fa-check text-success' : 'far fa-copy'} />
                                    </button>
                                )}
                            </span>
                        </div>
                        <div className="header-date-text">
                            <i className="far fa-calendar-alt" /> Waktu Pemesanan: <strong>{date || '-'}</strong>
                        </div>
                    </div>

                    <div className="header-status-right">
                        {status === 0 ? (
                            timer.isExpired ? (
                                <span className="order-status-pill status-cancelled">
                                    <i className="fas fa-ban mr-1" /> Dibatalkan (Waktu Habis)
                                </span>
                            ) : (
                                <span className="order-status-pill status-deadline">
                                    <i className="far fa-clock mr-1" /> Sisa Waktu Bayar: <strong>{timer.formatted}</strong>
                                </span>
                            )
                        ) : (
                            <span className={`order-status-pill ${statusBadge.badgeClass}`}>
                                <i className={`${statusBadge.icon} mr-1`} /> {statusBadge.label}
                            </span>
                        )}

                        {status === 0 && !timer.isExpired && orderId && (
                            <Link
                                to={`/account/order-produk/${orderId}`}
                                className="btn-pay-now-header"
                            >
                                <i className="fas fa-credit-card mr-1" /> Bayar Sekarang
                            </Link>
                        )}

                        {status === 0 && !timer.isExpired && (
                            <a
                                href={waConfirmUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-wa-confirm-header"
                            >
                                <i className="fab fa-whatsapp mr-1" /> Konfirmasi via WA
                            </a>
                        )}
                    </div>
                </div>

                {/* 2-Column Content Layout */}
                <div className="order-details-grid">
                    {/* LEFT COLUMN: Items & Payment Breakdown */}
                    <div className="order-details-main-col">
                        {/* Products List Card */}
                        <div className="order-section-card">
                            <div className="card-header-clean">
                                <h2 className="card-title-text">
                                    <i className="fas fa-shopping-bag" /> Rincian Produk
                                </h2>
                                <span className="badge-item-count">{item.length} Barang</span>
                            </div>

                            <div className="order-products-list">
                                {item.length > 0 ? (
                                    item.map((prod, index) => {
                                        const unitPrice = parseFloat(prod.price_6 || prod.price) || 0;
                                        const qty = parseInt(prod.qty, 10) || 1;
                                        const prodSubtotal = unitPrice * qty;

                                        return (
                                            <div key={prod.id || index} className="order-product-row">
                                                <div className="product-thumb-box">
                                                    <img
                                                        src={prod.image_url || prod.photo || prod.image || '/images/products/placeholder.jpg'}
                                                        alt={prod.item_name || 'Produk'}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = '/images/products/placeholder.jpg';
                                                        }}
                                                    />
                                                </div>

                                                <div className="product-info-col">
                                                    <div className="product-name-title">{prod.item_name}</div>
                                                    <div className="product-meta-qty">
                                                        {qty} barang x {formatRupiah(unitPrice)}
                                                    </div>
                                                </div>

                                                <div className="product-total-col">
                                                    <div className="product-subtotal-val">{formatRupiah(prodSubtotal)}</div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <EmptyState compact icon="box-open" title="Produk tidak tersedia" text="Daftar produk pesanan ini kosong." />
                                )}
                            </div>

                            {/* Summary Breakdown */}
                            <div className="order-summary-breakdown">
                                <div className="summary-line">
                                    <span>Subtotal Produk</span>
                                    <span className="line-val">{formatRupiah(subtotal)}</span>
                                </div>
                                <div className="summary-line">
                                    <span>Ongkos Kirim</span>
                                    <span className="line-val">{formatRupiah(ongkir)}</span>
                                </div>
                                <div className="summary-line total-line">
                                    <span>Total Tagihan</span>
                                    <span className="line-val">{formatRupiah(totalprice)}</span>
                                </div>
                            </div>
                        </div>

                        {/* Tracking History Card (if tracking available) */}
                        {lacak && lacak.length > 0 && (
                            <div className="order-section-card">
                                <div className="card-header-clean">
                                    <h2 className="card-title-text">
                                        <i className="fas fa-shipping-fast" /> Lacak Pengiriman
                                    </h2>
                                </div>

                                <div className="order-tracking-timeline">
                                    {lacak.map((step, idx) => (
                                        <div key={idx} className="tracking-step-item">
                                            <div className={`step-dot ${idx === 0 ? 'active' : ''}`}>
                                                <i className="fas fa-check" />
                                            </div>
                                            <div className="step-content">
                                                <div className="step-date">{step.date}</div>
                                                <div className="step-desc">{step.desc}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>

                    {/* RIGHT COLUMN: Shipping Address, Store Info & Support */}
                    <div className="order-details-side-col">
                        {/* Shipping Address Card */}
                        <div className="order-section-card">
                            <div className="card-header-clean">
                                <h2 className="card-title-text">
                                    <i className="fas fa-map-marker-alt" /> Alamat Pengiriman
                                </h2>
                            </div>

                            <div className="sidebar-info-block">
                                <div className="info-data-group">
                                    <span className="info-label">Penerima</span>
                                    <span className="info-value-main">{nama || '-'}</span>
                                    <span className="info-value-sub">
                                        <i className="fas fa-phone-alt mr-1 text-muted" /> {phone || '-'}
                                    </span>
                                </div>

                                <div className="info-data-group">
                                    <span className="info-label">Alamat Lengkap</span>
                                    <span className="info-value-sub">{address || '-'}</span>
                                </div>
                            </div>
                        </div>

                        {/* Store Info Card */}
                        <div className="order-section-card">
                            <div className="card-header-clean">
                                <h2 className="card-title-text">
                                    <i className="fas fa-store" /> Pengirim
                                </h2>
                            </div>

                            <div className="sidebar-info-block">
                                <div className="info-data-group">
                                    <span className="info-value-main text-primary">HOKKY BANGUNAN</span>
                                    <span className="info-value-sub">
                                        Jl. Raya Menganti No. 38, Wiyung, Surabaya Barat, Jawa Timur, 60227
                                    </span>
                                </div>

                                <div className="info-data-group">
                                    <span className="info-label">Customer Service</span>
                                    <span className="info-value-sub">
                                        <i className="fas fa-phone-alt mr-1 text-muted" /> 0812-3055-3236
                                    </span>
                                    <span className="info-value-sub">
                                        <i className="fas fa-envelope mr-1 text-muted" /> hokkybangunan.sby@gmail.com
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
